import Image from "next/image";
import dynamic from "next/dynamic";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Form, Row, InputGroup, Button } from "react-bootstrap";
import GreenCheckmark from "../../components/GreenCheckmark/GreenCheckmark";
import MainLayout from "../../components/MainLayout/MainLayout";
import iPhoneMockup from "../../assets/images/iPhoneMockup.png";
import Ball from "../../assets/images/ball-bask.png";
import { useQuery } from "@apollo/client";
import { getAllWpPostQuery } from "../blog";
import MarchMadnessLatestPosts from "../../components/MarchMadnessLatestPosts";
import { postRequest } from "../../utils/authGetRequest";
import { useCookies } from "react-cookie";
import Link from "next/link";
import ContentfulBlogs from "../../components/contentfulBlogs/ContentfulBlogs";
import { appServerSideProps } from "../../utils/getAppService";
import ScoreCard from "../../components/ScoreCard/ScoreCard";
import WelcomeScoreCards from "../../components/WelcomeScoreCards";
import Head from "next/head";
import Testimony from "../../components/home/Testimony";
import Utils from "../../utils/Utils";
import { SIGNUPS_CLOSED_MESSAGE } from "../../constants/main";
const MatchupTeamStats = dynamic(() => import("../../components/home/MatchupTeamStats"), { ssr: false });

const MarchMadness = ({ user }) => {
  const [isValid, setIsValid] = useState(false);
  const [emailAddress, setEmailAddress] = useState("");
  const [marchmadnessSubscribed, setMarchmadnessSubscribed] = useState(false);
  const [cookies, setCookie] = useCookies(["marchmadness_subscribed"]);
  const [teamData, setTeamData] = useState([]);
  const [targetReached, setTargetReached] = useState(false);
  const isPayed = Utils.hasPremiumPlan(user) || Utils.hasStandardPlan(user);

  useEffect(() => {
    setMarchmadnessSubscribed(cookies.marchmadness_subscribed);
    fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/college_mens/value-finder/games/hompage`)
      .then((response) => response.json())
      .then((response) => {
        if (response?.data[0]) {
          let game = response.data[0];
          game.league = "college_mens";

          setTeamData([game]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const useMediaQuery = (width) => {
    const updateTarget = useCallback((e) => {
      if (e.matches) {
        setTargetReached(true);
      } else {
        setTargetReached(false);
      }
    }, []);

    useEffect(() => {
      const media = window.matchMedia(`(max-width: ${width}px)`);
      media.addEventListener("change", updateTarget);

      // Check on mount (callback is not called until a change occurs)
      if (media.matches) {
        setTargetReached(true);
      }

      return () => media.removeEventListener("change", updateTarget);
    }, []);
    return targetReached;
  };
  const isBreakpoint = useMediaQuery(768);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  useEffect(() => {
    setIsValid(validateEmail(emailAddress));
  }, [emailAddress]);

  const handleSubmit = () => {
    if (isValid) {
      var data = {
        profiles: [
          {
            email: emailAddress,
          },
        ],
      };
      // postRequest("/api/marchmadness/email", {
      //   email: emailAddress,
      // });
      // setCookie("marchmadness_subscribed", true, {
      //   maxAge: 31536000,
      //   path: "/",
      // });
      // setMarchmadnessSubscribed(true);
      fetch(`${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/klaviyo/march_madness/${emailAddress}/save`)
        .then((res) => {
          if (res.status === 200) {
            setCookie("marchmadness_subscribed", true, {
              maxAge: 31536000,
              path: "/",
            });
            setMarchmadnessSubscribed(true);
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  return (
    <>
      <Head>
        <title>March Madness Bracket Predictions Powered by the Best Data in Basketball</title>
        <meta
          name="description"
          content={`March Madness bracketology powered by ShotQuality data. Get matchup previews, predictions, and live data for all games here.`}
        />
      </Head>
      <MainLayout>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mt-5">
              <h1 style={{ marginBottom: "25px" }}>
                Power your March Madness Picks and Predictions with the Best Data in Basketball
              </h1>
              <p style={{ textAlign: "center" }} className="text-black">
                We use computer vision and AI to deliver player location data that powers the most predictive shot
                models in basketball. Access cutting edge analytics to power your pregame picks and the only live data
                in NCAA Basketball.
              </p>
            </div>
          </div>
          <div className="row mt-4 mb-5">
            <div className="col-12 box-shadow-1 bg-white pt-4 pb-4 b-radius-1 ">
              <table className="table table-borderless ">
                <tbody>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">ScoreCenter - PREMIUM ONLY - </span> Your home for halftime in
                      March. Win more with access to live regression data for every game.
                    </td>
                  </tr>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">Value Bracket -</span>
                      Uncover opportunities by playing our value bracket which analyzes crowd picks against ShotQuality
                      picks to highlight value.
                    </td>
                  </tr>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">Matchup Analysis -</span>
                      Access matchup breakdowns for every possible tournament combination and winners based on
                      ShotQuality's predictive analytics.
                    </td>
                  </tr>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">Bracket Builder -</span>
                      Build your own bracket using one of ShotQuality’s strategies or fine-tune it by selecting from
                      projected performance.
                    </td>
                  </tr>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">Projected Scores -</span> Power your picks and predictions using
                      the best data in basketball.
                    </td>
                  </tr>
                  <tr>
                    <td className="fs-5">✅ </td>
                    <td>
                      <span className="fs-4 fw-8 pr-1">Members Only Content -</span>
                      Be the first to know with early access to picks and members only analysis in Discord and email.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="col-12 text-center mt-5">
              <p className="fw-8">{SIGNUPS_CLOSED_MESSAGE}</p>
            </div>
            <div className="col-12 text-center mt-1">
              <Link href={"/march-madness-primer-welcome"} className="text-black">
                Already Purchased? <span className="text-orange">Click here</span> to access the primer.
              </Link>{" "}
            </div>
            {/* <Col lg={6} md={12} xs={12}>
              <WelcomeScoreCards page="marchmadness" />
              <h3 className="text-center">Pick Of the Day</h3>
              {teamData.length > 0 && (
                <div className="row">
                  <div className="col-md-12">
                    <div className="d-flex justify-content-center flex-wrap">
                      {teamData.length > 0 &&
                        teamData.map((game) => {
                          return (
                            <div className="col-10 second" key={game.Away + game.Home}>
                              <MatchupTeamStats opponentName={game.Away} teamName={game.Home} league={game.league} />
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </Col> */}
          </div>

          {!marchmadnessSubscribed ||
            (!isPayed && (
              <>
                <div className="text-center">
                  <h1>Not ready to level up your March Madness?</h1>
                  <p>Enter your email to get our FREE pick of the day</p>
                </div>
                <Row className="mm-email-wrapper justify-center">
                  <Form className="mm-form">
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <InputGroup className="mb-3 mm-input-main-wrapper">
                        <InputGroup.Text
                          id="basic-addon2"
                          className="mm-icon-wrapper"
                          style={{
                            backgroundColor: "white",
                            borderRight: "none",
                            fontSize: "14px",

                            borderTopLeftRadius: "8px",
                            borderBottomLeftRadius: "8px",
                            borderTop: "1px solid #ced4da",
                            borderBottom: "1px solid #ced4da",
                            borderLeft: "1px solid #ced4da",
                            borderTopRightRadius: "0px",
                            borderBottomRightRadius: "0px",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3 3H15C15.825 3 16.5 3.675 16.5 4.5V13.5C16.5 14.325 15.825 15 15 15H3C2.175 15 1.5 14.325 1.5 13.5V4.5C1.5 3.675 2.175 3 3 3Z"
                              stroke="#6B6C72"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M16.5 4.5L9 9.75L1.5 4.5"
                              stroke="#6B6C72"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </InputGroup.Text>
                        <Form.Control
                          className="mm-email-input-wrapper"
                          icon
                          onChange={(e) => setEmailAddress(e.target.value)}
                          style={{
                            borderLeft: "none",
                            display: "flex",
                            justifyContent: "center",
                            fontSize: "14px",
                            borderTopRightRadius: "8px",
                            borderBottomRightRadius: "8px",
                            borderTopLeftRadius: "0px",
                            paddingLeft: "0px",
                            borderTop: "1px solid #ced4da",
                            borderBottom: "1px solid #ced4da",
                            borderBottomLeftRadius: "0px",
                            width: "350px",
                          }}
                          placeholder="Enter your email"
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                        />
                        <Button
                          className={`mm-access-button ${isBreakpoint ? "mx-auto" : "mx-4"}`}
                          style={{ backgroundColor: "black", color: "white", padding: "5px 15px", marginLeft: "50px" }}
                          disabled={!isValid}
                          onClick={() => handleSubmit()}
                        >
                          Get Access
                        </Button>
                      </InputGroup>
                    </Form.Group>
                  </Form>
                </Row>
              </>
            ))}
          {marchmadnessSubscribed && (
            <Row
              className="mm-email-wrapper"
              style={{
                justifyContent: "center",
              }}
            >
              <Col
                lg={6}
                xs={12}
                md={6}
                style={{
                  backgroundColor: "#fff",
                  border: "1px solid #D0D2D9",
                  padding: "40px 60px",
                  borderRadius: "16px",
                  textAlign: "center",
                }}
              >
                <Image
                  style={{
                    marginBottom: "24px",
                  }}
                  width={42}
                  height={42}
                  src={Ball}
                />
                <h1 style={{ marginBottom: "25px" }}>Great!</h1>
                <p>
                  You're in! Check out the <Link href={"/value-bracket"}>Value Bracket</Link>,{" "}
                  <Link href={"/march-madness-matchups"}>Match Ups</Link>,
                  {/* <Link href={"/linevalue"}>Predictions</Link>{" "} */}
                  and <Link href={"model-results"}>Results</Link>
                </p>
              </Col>
            </Row>
          )}
          {/* <Row
          style={{
            backgroundColor: "#f3f4f6",
          }}
        >
          <p className="mm-predictions-header mb-5" style={{ marginLeft: "50px" }}>
            March Madness Predictions and Analysis
          </p>
          {data && <MarchMadnessLatestPosts posts={data.posts.posts.slice(0, 3)} />}
        </Row> */}
          <div className="bg-white p-2 row b-radius-2">
            <Testimony />
          </div>
          <div className="container">
            <ContentfulBlogs user={user} tag="marchMadness" />
          </div>
        </div>
      </MainLayout>
    </>
  );
};

export const getServerSideProps = appServerSideProps(async ({ appService, cookies, params, query }) => {
  const isUserLogged = appService.getUser();
  let user = null;
  if (isUserLogged) {
    user = await appService.get("api/account");
  }

  return {
    props: {
      user,
    },
  };
});

export default MarchMadness;
